<div class="tw:w-full tw:max-w-7xl tw:mx-auto tw:px-4 tw:pt-24">
  <div class="tw:flex tw:flex-wrap error-page tw:items-center">
    <div class="error-page-content tw:w-full tw:md:w-1/2">
      <h1 i18n>Segment error</h1>
      <p i18n> The company segment configuration is invalid. Expected A2B3 or C3D3. Please contact support.</p>
      <p> {{ errorMessageSignal() }} </p>
      <button class="ga-button ga-button--primary" (click)="backToHome()" i18n> Back to Visma.net Home</button>
    </div>
    <div class="error-page-image tw:w-full tw:md:w-1/2 tw:h-[384px]">
      <div class="tw:w-[384px] tw:h-[384px] segment-error-image"> </div>
    </div>
  </div>
</div>
